<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
      :active.sync="loader"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <Header />

    <b-card class="bCardGlobal">
      <b-row class="divSubtitulo m-1 mb-3">
        <b-col cols="6" md="10">
          <div>
            <p class="textoSubtitulo">Colaboradores</p>
          </div>
        </b-col>
        <b-col cols="6" md="2">
          <div>
            <p style="text-align: end" class="textoSubtitulo">BO_15_Colab</p>
          </div>
        </b-col>
      </b-row>

      <div class="tabs mt-4">
        <nav class="tabs-nav">
          <ul>
            <li
              :class="{ active: tabSeleccionada === index }"
              v-for="(tab, index) in tabs"
              :key="index"
            >
              <a @click="seleccionarTab(index)" href="#">
                {{ tab.descripcion }}
                <hr
                  v-if="tabSeleccionada === index"
                  style="background-color: #0069a9; height: 2px; width: 60%"
                />
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div class="w-100" id="colaboradores activos" v-if="tabSeleccionada === 0">
        <b-row class="justify-content-center mt-4">
          <b-col cols="7">
            <div class="d-flex justify-content-center">
              <div class="barras d-flex" style="width: 100%; margin-top: 10px">
                <b-form-input
                  v-if="$localStorageService.can('BO_15_colob_Acti')"
                  @keydown.enter.native="obtenerColaboradores(1, true)"
                  class="input-filter"
                  v-model="filter"
                  placeholder="Búsqueda de colaboradores activos"
                  type="text"
                >
                </b-form-input>
                <b-button class="btn-extra-small" variant="info" @click="obtenerColaboradores(1, true)">
                  <span>
                    <em class="buscar_svg" style="margin-top: 3px; height: 13px">
                    </em
                  ></span>
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col cols="1" class="mt-3 text-left">
            <div class="d-flex">
              <b-button
                v-if="$localStorageService.can('BO_15_colob_Acti_crear')"
                variant="primary"
                v-b-tooltip.hover
                title="Crear un nuevo colaborador"
                class="paddingbotones botonesAzulFuerte"
                responsive
                @click="llamarModal(null, true, $event.target)"
                ><em class="colaborador icon-boton"></em>
              </b-button>
              <b-button
                v-if="colaboradoresActivosExcel.length === 0 && $localStorageService.can('BTN_excel_colaborador')"
                variant="success"
                v-b-tooltip.hover
                title="Generar excel"
                class="ml-2 paddingbotones"
                style="border-radius: 10rem"
                responsive
                @click="obtenerColaboradoresActivosExcel"
                :disabled="loader"
                ><em class="excel icon-boton"></em>
              </b-button>
            </div>
          </b-col>
        </b-row>
        <download-excel
          class="mt-3 btn btn-success mr-3"
          v-if="
            colaboradoresActivosExcel.length === 0 &&
            $localStorageService.can('BTN_excel_colaborador')
          "
          :data="colaboradoresActivosExcel"
          :fields="fieldsExcel"
          worksheet="Activos"
          name="Colaboradores Activos.xls"
        >
          Descargar Excel
        </download-excel>
        <div id="tablaColaboradoresActivos" class="contenedorTablaSinColor p-3 mt-5" style="">
          <b-table
            style="border-radius: 10px"
            :fields="fields"
            :items="items"
            :per-page="registrosPorPagina"
            :current-page="1"
            responsive
          >
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                  v-if="$localStorageService.can('BO_15_editar')"
                  v-b-tooltip.bottomleft
                  title="Editar"
                  size="sm"
                  @click="llamarModal(row.item, false, $event.target)"
                  class="mr-1 marginbotones"
                  variant="outline-warning"
                >
                  <b-icon icon="pencil"></b-icon>
                </b-button>

                <b-button
                  v-if="$localStorageService.can('BO_15_baja')"
                  v-b-tooltip.bottomleft
                  title="Dar de baja"
                  variant="outline-danger"
                  class="mr-1 marginbotones"
                  size="sm"
                  @click="
                    actualizarColaborador(
                      row.item.idEmpleado,
                      row.item.nombre,
                      false
                    )
                  "
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
                <b-button
                  v-b-tooltip.bottomleft
                  title="Enviar correo"
                  variant="outline-success"
                  class="mr-1 marginbotones"
                  size="sm"
                  @click="enviarCorreoFirma(row.item.idEmpleado)"
                >
                  <b-icon icon="folder-symlink"></b-icon>
                </b-button>
                <!--                          Enviar correo para recabar firma  -->
              </b-button-group>
            </template>
          </b-table>
        </div>
        <b-pagination
          class="mt-2"
          align="center"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="registrosPorPagina"
        ></b-pagination>
      </div>

      <div v-if="tabSeleccionada == 1">
        <b-row class="justify-content-center mt-4">
          <b-col cols="7">
            <div class="d-flex justify-content-center">
              <div class="barras d-flex" style="width: 100%; margin-top: 10px">
                <b-form-input
                  v-if="$localStorageService.can('BO_15_colob_Inactivos')"
                  @keydown.enter.native="obtenerColaboradoresInactivos(1, true)"
                  class="input-filter"
                  v-model="filterInactivos"
                  placeholder="Búsqueda de colaboradores inactivos"
                  type="text"
                >
                </b-form-input>
                <b-button
                  class="btn-extra-small"
                  variant="info"
                  @click="obtenerColaboradores(1, true)"
                >
                  <span
                    ><em
                      class="buscar_svg"
                      style="margin-top: 3px; height: 13px"
                    ></em
                  ></span>
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col
            cols="1"
            class="mt-3 text-left"
            v-if="
              colaboradoresInactivosExcel.length === 0 &&
              $localStorageService.can('BTN_excel_colaborador')
            "
          >
            <b-button
              variant="success"
              v-b-tooltip.hover
              title="Generar excel"
              class="paddingbotones"
              style="border-radius: 10rem"
              responsive
              @click="obtenerColaboradoresInactivosExcel"
              :disabled="loader"
              ><em class="excel icon-boton"></em>
            </b-button>
          </b-col>
        </b-row>
        <download-excel
          class="mt-3 btn btn-success"
          v-if="
            colaboradoresInactivosExcel.length > 0 &&
            $localStorageService.can('BTN_excel_colaborador')
          "
          :data="colaboradoresInactivosExcel"
          :fields="fieldsExcel"
          worksheet="Inactivos"
          name="Colaboradores inactivos.xls"
        >
          Descargar Excel
        </download-excel>
        <div class="contenedorTablaSinColor mt-5">
          <b-table
            :fields="fieldsInactivos"
            :items="itemsInactivos"
            responsive="true"
            caption-top
            fixed
          >
            <template v-slot:cell(Acciones)="row">
              <b-button
                v-b-tooltip.hover
                title="Dar de alta"
                size="sm"
                @click="
                  actualizarColaborador(
                    row.item.idEmpleado,
                    row.item.nombre,
                    true
                  )
                "
                class="mr-1 marginbotones"
                variant="outline-success"
              >
                <b-icon icon="arrow-counterclockwise"></b-icon>
              </b-button>
            </template>
          </b-table>
        </div>
        <b-pagination
          align="center"
          v-model="currentPageInactivo"
          :total-rows="rowsInactivo"
          :per-page="registrosPorPaginaInactivos"
        ></b-pagination>
      </div>
    </b-card>
    <b-modal
      v-if="$localStorageService.can('BO_15_colob_Acti_crear')"
      size="xl"
      :id="'modalcrear'"
      :title="titulo"
      scrollable
      no-close-on-backdrop
    >
      <CrearEditar
        v-if="mostrarModal"
        :objetoColaboradorEntrada="informacionModal"
        :tiposRegimen="tiposRegimen"
        :canalesOrigen="canalesOrigen"
        @crearColaborador="crearColaborador"
        ref="modalCrear"
      />
      <template #modal-footer="{ ok, cancel }">
        <b-button
          v-if="$localStorageService.can('BO_15_colob_Acti_crear')"
          class="mt-3 botonesfooter"
          variant="outline-primary"
          style="width: 10%; margin: 10px"
          block
          @click="$refs.modalCrear.$refs.submitGuardar.click()"
          :disabled="loaderAcciones"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>

        <b-button
          class="mt-3 botonesfooter"
          variant="outline-danger"
          style="width: 10%; margin: 10px"
          block
          @click="
            () => {
              mostrarModal = false;
              $bvModal.hide('modalcrear');
            }
          "
          >Cerrar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      size="xl"
      :id="'modalInfoEmp'"
      :title="titulo"
      scrollable
      no-close-on-backdrop
    >
      <InformacionEmpleado
        v-if="mostrarModal"
        :objetoColaboradorEntrada="informacionModal"
        @crearColaborador="crearColaborador"
        ref="modalInfoEmp"
      />
      <template #modal-footer="{ ok, cancel }">
        <b-button
          class="mt-3 botonesfooter"
          variant="outline-danger"
          style="width: 10%; margin: 10px"
          block
          @click="
            () => {
              mostrarModal = false;
              $bvModal.hide('modalInfoEmp');
            }
          "
          >Cerrar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="continuarProcesoModal"
      :title="`No se puede inactivar el colaborador, se enviará solicitudes a las clínicas correspondientes (${datosContinuarProcesoInactivarColaborador.nombreClinica})`"
      size="lg"
      hide-footer
    >
      <b-row>
        <b-col sm="3"> </b-col>
        <b-col sm="6">
          <br />

          <p>
            <i class="fa fa-check-square" aria-hidden="true"></i> Citas
            agendadas:
            {{ datosContinuarProcesoInactivarColaborador.numeroCitas }}
          </p>
          <p>
            <i class="fa fa-check-square" aria-hidden="true"></i> Horarios
            asignados:
            {{ datosContinuarProcesoInactivarColaborador.numeroHorarios }}
          </p>
          <p>
            <i class="fa fa-check-square" aria-hidden="true"></i> Tratamientos
            programados asignados:
            {{ datosContinuarProcesoInactivarColaborador.numeroProgramados }}
          </p>
          <br />
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="4"> </b-col>
        <b-col sm="4">
          <b-button
            class="mt-3"
            block
            variant="outline-primary"
            @click="$bvModal.hide('continuarProcesoModal')"
            >Aceptar</b-button
          ></b-col
        >
      </b-row>

      <b-row>
        <b-col sm="12"> </b-col>
      </b-row>

      <!-- <h5>{{datosContinuarProcesoInactivarColaborador.mensaje}}</h5> -->

      <br />
    </b-modal>
    <!--          Modal para firma Colaborador              -->

  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import CrearEditar from "../../components/Colaboradores/CrearEditarColaborador.vue";
import InformacionEmpleado from "../../components/Colaboradores/InformacionEmpleado";
import { FirmaService } from "../../apiServices/firma/FirmaService";
export default {
  name: "BandejaQuejas",
  components: {
    Header,
    CrearEditar,
    InformacionEmpleado,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      loader: false,
      tabSeleccionada: 0,
      opcionTabSeleccionada: 0,
      tabs: [
        { descripcion: "Colaboradores activos" },
        { descripcion: "Colaboradores inactivos" },
      ],
      getDatosFirma: null,
      firmaService: new FirmaService(),
      loaderColabAct: false,
      loaderColabInact: false,
      loaderClinicas: false,
      loaderSexo: false,
      loaderEdoCivil: false,
      loaderEsquema: false,
      loaderOcupacion: false,
      loaderTipoEmpleado: false,
      loaderTipoPago: false,
      loaderGuardar: false,
      loaderSegmento: false,
      loaderEspecialidades: false,

      rows: 0,
      rowsInactivo: 0,

      mostrarModal: false,
      mostrarModalFirma: false,
      loaderAcciones: false,
      filter: null,
      filterInactivos: null,
      currentPage: 1,
      currentPageInactivo: 1,
      informacionModal: {
        idmodal: "modalcreareditar",
        crear: null,
        objetoColaborador: "",
        catalogos: {
          sexo: [],
          estadocivil: [],
          esquema: [],
          ocupacion: [],
          tipoEmpleado: [],
          clinicas: [],
          tipoPago: [],
        },
      },
      titulo: null,
      fields: [
        { key: "idEmpleado", label: "Id colaborador" },
        { key: "numeroEmpleado", label: "Id ERP" },
        { key: "nombre", label: "Nombre de colaborador" },
        {
          key: "fechaModificacion",
          label: "Fecha de modificación",
          formatter: this.$formatoFechaHora,
        },
        {
          key: "nombreEmpleadoModificacion",
          label: "Nombre usuario que modificó",
        },
        "Acciones",
      ],
      fieldsInactivos: [
        { key: "idEmpleado", label: "Id colaborador" },
        { key: "numeroEmpleado", label: "Id ERP" },
        { key: "nombre", label: "Nombre de colaborador" },
        {
          key: "fechaModificacion",
          label: "Fecha Modificación de datos",
          formatter: this.$formatoFechaHora,
        },
        {
          key: "nombreEmpleadoModificacion",
          label: "Nombre usuario que modificó",
        },
        "Acciones",
      ],
      items: [],
      itemsInactivos: [],
      objetoColaborador: {
        idCompania: null,
        idEmpleadoJefe: null,
        idSegmento: null,
        empAbbr: null,
        strCedula: null,
        strCorreo: null,
        crmId: null,
        fechaAlta: "2019-02-02",
        tiempoCompleto: null,
        usuarioAlta: null,
        usuarioModificacion: null,
        nivel: null,
        numeroEmpleado: null,
        registroActivo: null,
        telCasa: null,
        telCelular: null,
        telTrabajo: null,
        fechaModificacion: "2019-03-02",
        fechaIngreso: "2019-03-02",
        idPersona: {
          idPersona: null,
          nombre: null,
          fechaModificacion: "2020-01-01",
          registroActivo: null,
          fechaNacimiento: "2020-01-01",
          fechaAlta: "2020-01-01",
          materno: null,
          paterno: null,
          token: null,
          sexo: {
            id: 1,
          },
        },
        tiposRegimen: [],
        canalesOrigen: [],
      },
      datosContinuarProcesoInactivarColaborador: [],
      registrosPorPagina: 15,
      registrosPorPaginaInactivos: 30,
      fieldsExcel: {
        "ID Colaborador": "idEmpleado",
        "Nombre de colaborador": "nombre",
        "Fecha de Modificación": "fechaModificacion",
        "Nombre usuario que modificó": "nombreEmpleadoModificacion",
      },
      colaboradoresActivosExcel: [],
      colaboradoresInactivosExcel: [],
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerColaboradoresInactivos(1, true);
    this.obtenerColaboradores(1, true);
    this.obtenerCatalogos();
    this.obtenerTiposDeRegimen();
    this.obtenerCanalesOrigen();
  },
  watch: {
    currentPage() {
      this.obtenerColaboradores(this.currentPage, false);
    },
    currentPageInactivo() {
      this.obtenerColaboradoresInactivos(this.currentPageInactivo, false);
    },
  },
  methods: {
    seleccionarTab(index) {
      this.tabSeleccionada = index;
      this.opcionTabSeleccionada = 0;
    },
    obtenerCanalesOrigen() {
      this.$http
        .get(this.$api + "catalogos/obtenerCanalesOrigen")
        .then((response) => {
          this.canalesOrigen = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    obtenerTiposDeRegimen() {
      this.$http
        .get(this.$api + "colaboradores/obtenerTiposDeRegimen")
        .then((response) => {
          this.tiposRegimen = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    limpiarFiltro() {
      this.filtro = {
        estatus: [],
        clinicas: [],
        clasificaciones: null,
        nombre: null,
        fechaInicio: null,
        fechaFin: null,
      };
    },
    obtenerCatalogos() {
      this.listaClinicas();
      this.listaSexo();
      this.listaEstadoCivil();
      this.listaEsquema();
      this.listaOcupacion();
      this.listaTipoEmpleado();
      this.listaTipoPago();
      this.listaSegmentos();
      this.listaEspecialidades();
    },
    listaTipoPago() {
      this.loaderTipoPago = true;
      let peticion = this.$api + "catalogos/listaTipoPago" + this.$apiToken;
      this.$http
        .get(peticion)
        .then((response) => {
          this.informacionModal.catalogos.tipoPago = response.data.data;
          return new Promise((resolve) => {
            resolve(response);
          });
        })
        .catch()
        .finally(() => {
          this.loaderTipoPago = false;
        });
    },
    listaSexo() {
      this.loaderSexo = true;
      let peticion = this.$api + "catalogos/listaSexo" + this.$apiToken;
      this.$http
        .post(peticion)
        .then((response) => {
          this.informacionModal.catalogos.sexo = response.data.data;
          return new Promise((resolve) => {
            resolve(response);
          });
        })
        .catch()
        .finally(() => {
          this.loaderSexo = false;
        });
    },
    listaClinicas() {
      this.loaderClinicas = true;
      let peticion = this.$api + "catalogos/listaClinicas" + this.$apiToken;
      this.$http
        .get(peticion)
        .then((response) => {
          this.informacionModal.catalogos.clinicas = response.data.data;
          return new Promise((resolve) => {
            resolve(response);
          });
        })
        .catch()
        .finally(() => {
          this.loaderClinicas = false;
        });
    },
    listaEsquema() {
      this.loaderEsquema = true;
      let peticion = this.$api + "catalogos/listaEsquema" + this.$apiToken;
      this.$http
        .get(peticion)
        .then((response) => {
          this.informacionModal.catalogos.esquema = response.data.data;
          return new Promise((resolve) => {
            resolve(response);
          });
        })
        .catch()
        .finally(() => {
          this.loaderEsquema = false;
        });
    },
    listaEstadoCivil() {
      this.loaderEdoCivil = true;
      let peticion = this.$api + "catalogos/listaEstadoCivil" + this.$apiToken;
      this.$http
        .get(peticion)
        .then((response) => {
          this.informacionModal.catalogos.estadocivil = response.data.data;
          return new Promise((resolve) => {
            this.$swal.close();
            resolve(response);
          });
        })
        .catch()
        .finally(() => {
          this.loaderEdoCivil = false;
        });
    },
    listaOcupacion() {
      this.loaderOcupacion = true;
      let peticion = this.$api + "catalogos/listaOcupacion" + this.$apiToken;
      this.$http
        .get(peticion)
        .then((response) => {
          this.informacionModal.catalogos.ocupacion = response.data.data;
          return new Promise((resolve) => {
            this.$swal.close();
            resolve(response);
          });
        })
        .catch()
        .finally(() => {
          this.loaderOcupacion = false;
        });
    },

    listaTipoEmpleado() {
      this.loaderTipoEmpleado = true;
      let peticion =
        this.$api + "catalogos/tipo/empleado/obtener/lista" + this.$apiToken;
      this.$http
        .get(peticion)
        .then((response) => {
          this.informacionModal.catalogos.tipoEmpleado = response.data.data;
          return new Promise((resolve) => {
            this.$swal.close();
            resolve(response);
          });
        })
        .catch()
        .finally(() => {
          this.loaderTipoEmpleado = false;
        });
    },

    listaSegmentos() {
      this.loaderSegmento = true;
      let peticion = this.$api + "catalogos/obtenerSegmentosEmpleado";
      this.$http
        .get(peticion)
        .then((response) => {
          this.informacionModal.catalogos.segmentos = response.data.data.map(
            (s) => {
              return {
                idSegmento: s.idSegmento,
                descripcion:
                  s.minTransaccionesMes + " - " + s.maxTransaccionesMes + "tx",
              };
            }
          );

          return new Promise((resolve) => {
            this.$swal.close();
            resolve(response);
          });
        })
        .catch()
        .finally(() => {
          this.loaderSegmento = false;
        });
    },
    listaEspecialidades() {
      this.loaderEspecialidades = true;
      let peticion = this.$api + "catalogos/obtenerEspecialidades";
      this.$http
        .get(peticion)
        .then((response) => {
          this.informacionModal.catalogos.especialidades = response.data.data;
          return new Promise((resolve) => {
            this.$swal.close();
            resolve(response);
          });
        })
        .catch()
        .finally(() => {
          this.loaderEspecialidades = false;
        });
    },
    crearColaborador(valores) {
      const config = {
        header: {
          "Content-Type": "image/png",
        },
      };

      this.loaderAcciones = true;

      const objGuardar = JSON.parse(JSON.stringify(valores));

      objGuardar.fechaAlta =
        objGuardar.fechaAlta != null
          ? this.$moment(objGuardar.fechaAlta)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm[:00Z]")
          : null;
      objGuardar.fcNacimiento = this.$moment(objGuardar.fcNacimiento)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm[:00Z]");

      const found = objGuardar.idClinica.filter(
        (element) => element == undefined
      );

      if (found.length > 0) {
        found.forEach((dato) => {
          let index = objGuardar.idClinica.indexOf(dato);
          objGuardar.idClinica.splice(index, 1);
        });
      }
      objGuardar.nombre = objGuardar.nombre.trim();
      objGuardar.paterno = objGuardar.paterno.trim();
      objGuardar.materno = objGuardar.materno.trim();
      objGuardar.idCanalOrigen = 1;
      this.$http
        .post(this.$api + "colaboradores/crearColaborador", objGuardar, config)
        .then((response) => {
          this.$swal.fire({
            position: "center",
            icon: "success",
            title:
              "Se guardo al colaborador con el usuario: " + response.data.data,
            showConfirmButton: false,
            timer: 5000,
          });

          this.filter =
            objGuardar.nombre +
            " " +
            objGuardar.paterno +
            " " +
            objGuardar.materno;
          this.obtenerColaboradores(1, true);
          this.$bvModal.hide("modalcrear");
          this.$bvModal.hide("modalFirmar");
          this.$bvModal.hide("modalInfoEmp");
          this.mostrarModal = false;
          this.mostrarModalFirma = false;

          return new Promise((resolve) => {
            resolve(response);
          });
        })
        .catch((error) => {
          this.$swal.fire({
            position: "center",
            icon: "error",
            title: error.response.data.message,
            showConfirmButton: false,
            timer: 2500,
          });
        })
        .finally(() => {
          this.loaderAcciones = false;
        });
    },
    actualizarColaborador(idEmpleado, nombre, registroActivo) {
      this.datosContinuarProcesoInactivarColaborador = [];
      var textoAccion = "";
      if (!registroActivo) {
        textoAccion = "¿Desea dar de baja al colaborador?";
      } else {
        textoAccion = "¿Desea dar de alta al colaborador?";
      }
      this.$swal.fire({
        title: textoAccion,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,

        preConfirm: () => {
          this.loader = true;
          this.loaderGuardar = true;
          const params = {
            idEmpleado: idEmpleado,
            activar: registroActivo,
          };
          let peticion =
            this.$api + "colaboradores/activarDesactivarColaborador";
          this.$http
            .post(peticion, params)
            .then((response) => {

              if (registroActivo) {
                this.filter = nombre;
              } else {
                this.filterInactivos = nombre;
              }

              if (response.data.data.continuarProceso == true) {
                this.$swal.fire({
                  title: response.data.message,
                  icon: "success",
                  confirmButtonText: "Aceptar",
                  showLoaderOnConfirm: true,
                  preConfirm: () => {
                  },
                });
                this.obtenerColaboradores(1, true);
                this.obtenerColaboradoresInactivos(1, true);
              } else {
                this.$bvModal.show("continuarProcesoModal");
                this.datosContinuarProcesoInactivarColaborador =
                  response.data.data;
              }
            })
            .catch(() => {
              this.$swal.fire({
                position: "center",
                icon: "error",
                title: "Hubo un error al actualizar al colaborador",
                showConfirmButton: false,
                timer: 2000,
              });
            })
            .finally(() => {
              this.loaderGuardar = false;
              this.loader = false;
            });
        },
      });
    },
    llamarModal(item, crear, button) {
      if (crear === true) {
        this.mostrarModal = true;
        this.titulo = "Crear un nuevo colaborador";
        this.informacionModal.idmodal = "modalcrear";
        this.informacionModal.objetoColaborador = "";
        this.informacionModal.crear = true;
        this.$root.$emit(
          "bv::show::modal",
          this.informacionModal.idmodal,
          button
        );
        this.informacionModal.objetoColaborador = null;
      } else {
        this.mostrarModal = true;
        this.titulo = "INFORMACIÓN DEL COLABORADOR: " + item.nombre;
        this.informacionModal.idmodal = "modalcrear";
        this.informacionModal.objetoColaborador = {
          idPersona: item.idPersona.idPersona,
          numeroEmpleado: item.numeroEmpleado,
        };
        this.informacionModal.crear = false;
        this.$root.$emit(
          "bv::show::modal",
          this.informacionModal.idmodal,
          button
        );
        
      }
      localStorage.setItem("infoColaborador", JSON.stringify(this.informacionModal));
      localStorage.setItem("tiposRegimen", JSON.stringify(this.tiposRegimen));
      localStorage.setItem("canalesOrigen", JSON.stringify(this.canalesOrigen));

      this.$router.push({name: "CrearEditarColaborador", params: {}});
    },

    verInformacionEmpleado(item, button) {
      this.mostrarModal = true;
      this.titulo = "INFORMACIÓN DEL COLABORADOR: " + item.nombre;
      this.informacionModal.idmodal = "modalInfoEmp";
      this.informacionModal.objetoColaborador = {
        idPersona: item.idPersona.idPersona,
      };
      this.informacionModal.crear = false;
      this.$root.$emit(
        "bv::show::modal",
        this.informacionModal.idmodal,
        button
      );
    },

    obtenerColaboradores(pagina, actualizarTotal) {
      this.loaderColabAct = true;
      this.items = [];
      if (actualizarTotal) {
        this.currentPage = pagina;
        this.rows = 0;
      }
      const params = {
        pagina: this.currentPage,
        filtro: this.filter,
      };
      this.$http
        .post(this.$api + "colaboradores/obtenerDoctoresActivos", params)
        .then((response) => {
          this.rows = response.data.data.total;
          this.items = response.data.data.colaboradores;
        })
        .catch()
        .finally(() => {
          this.loaderColabAct = false;
        });
    },
    obtenerColaboradoresInactivos(pagina, actualizarTotal) {
      this.loaderColabInact = true;
      this.itemsInactivos = [];
      if (actualizarTotal) {
        this.currentPageInactivo = pagina;
        this.rowsInactivo = 0;
      }
      const params = {
        pagina: this.currentPageInactivo,
        filtro: this.filterInactivos,
      };
      this.$http
        .post(this.$api + "colaboradores/obtenerDoctoresInactivos", params)
        .then((response) => {
          this.rowsInactivo = response.data.data.total;
          this.itemsInactivos = response.data.data.colaboradores;
        })
        .catch()
        .finally(() => {
          this.loaderColabInact = false;
        });
    },
    enviarCorreoFirma(idEmpleado) {
      for (var al = ""; al.length < 20; )
        al += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz"[
          (Math.random() * 60) | 0
        ];
      this.token = al;
      this.loaderOcupacion = true;
      this.$http
        .get(
          this.$api +
            "correos/firmaExternaColaborador/" +
            idEmpleado +
            "/" +
            this.token
        )
        .then((r) => {
          if (r.status == 200) {
            this.$swal({
              icon: "success",
              text: "Correo enviado al colaborador",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          } else {
            this.$swal({
              icon: "warning",
              text: "Ups! algo salió mal",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }
        })
        .finally(() => {
          this.loaderOcupacion = false;
        });
    },
    obtenerColaboradoresActivosExcel() {
      this.$swal.fire({
        title: "Este proceso podría tardar varios minutos, ¿desea continuar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          this.loader = true;

          this.$http
            .get(this.$api + "colaboradores/obtenerDoctoresActivosExcel")
            .then((response) => {
              this.colaboradoresActivosExcel = response.data.data.colaboradores;

              this.colaboradoresActivosExcel.forEach((colaboradores) => {
                colaboradores.fechaModificacion =
                  this.$global.traerFechaHoraLocal(
                    colaboradores.fechaModificacion
                  );
              });

              this.$swal.fire({
                icon: "success",
                title: "Aviso",
                text: "Generado correctamente",
              });
            })
            .catch((error) => {
              console.error(error);
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrió un error al consultar la información, por favor intente más tarde",
              });
            })
            .finally(() => {
              this.loader = false;
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
      });
    },
    obtenerColaboradoresInactivosExcel() {
      if (this.colaboradoresInactivosExcel.length === 0) {
        this.$swal.fire({
          title: "Este proceso podría tardar varios minutos, ¿desea continuar?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.loading = true;
            this.loading = true;
            this.$http
              .get(this.$api + "colaboradores/obtenerDoctoresInactivosExcel")
              .then((response) => {
                this.colaboradoresInactivosExcel =
                  response.data.data.colaboradores;

                this.colaboradoresInactivosExcel.forEach((colaboradores) => {
                  colaboradores.fechaModificacion =
                    this.$global.traerFechaHoraLocal(
                      colaboradores.fechaModificacion
                    );
                });

                this.$swal.fire({
                  icon: "success",
                  title: "Aviso",
                  text: "Generado correctamente",
                });
              })
              .catch((error) => {
                console.error(error);
                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  text: "Ocurrió un error al consultar la información, por favor intente más tarde",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
        });
      }
    },
  },

  computed: {
    loading() {
      return (
        this.loaderColabAct ||
        this.loaderColabInact ||
        this.loaderClinicas ||
        this.loaderSexo ||
        this.loaderTipoPago ||
        this.loaderEsquema ||
        this.loaderEdoCivil ||
        this.loaderOcupacion ||
        this.loaderGuardar ||
        this.loaderSegmento ||
        this.loaderEspecialidades
      );
    },
    linkFirma: function () {
      return document.location.origin + "/firmaColaborador/" + this.idEmpleado;
    },
  },
};
</script>

<style scoped>
.tabs {
  position: relative;
  width: 40%;
}

.tabs .tabs-nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.tabs .tabs-nav ul li {
  flex: 1 0 auto;
  margin: 0;
  border-bottom: 3px solid transparent;
}

.tabs .tabs-nav ul li a {
  display: block;
  padding: 0.4em 2em 0.4em 2em;
  border: none;
  color: #aaaaaa;
}

.tabs .tabs-nav ul li a:hover {
  /* al sobre poner el mouse */
  color: #369bda;
}

.border {
  /* borde inferior */
  border-bottom: 3px solid #0069a9;
  width: 20%;
}

.tabs .tabs-nav ul li.active a {
  color: #0069a9;
  font-weight: 600;
}

.tabs .tabs-content {
  width: 100%;
}

.barras {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
  padding-right: 2%;
  padding-left: 1%;
  border-radius: 20px;
  text-align: left;
  align-items: center;
}

.btn-extra-small {
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  line-height: 1.5;
}

.botonesAzulFuerte {
  border-radius: 10rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-left: 5%;
}

.paddingbotones {
  padding: 5px;
}

.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}

/* antiguo */

.scroll {
  max-height: 500px;
  overflow-y: auto;
}

.barra {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin: 1rem;
  padding: 5px;
  border-radius: 6px;
  text-align: left;
  align-items: center;
}

.row {
  background: transparent !important;
}

.input-filter,
.input-filter:focus {
  background: transparent;
  border: 0px;
  box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
}
.contenedor-drop {
  overflow: auto;
  max-height: 15em;
}

label {
  font-weight: 100 !important;
}

.btn-clear {
  color: gray;
  position: relative;
  margin-right: 1em;
}
.btn-clear:hover {
  color: black;
  cursor: pointer;
}
.btn-clear:focus {
  color: black;
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}
</style>
